import { render, staticRenderFns } from "./ImagesGallery.vue?vue&type=template&id=277d1b5e&scoped=true&"
import script from "./ImagesGallery.vue?vue&type=script&lang=ts&"
export * from "./ImagesGallery.vue?vue&type=script&lang=ts&"
import style0 from "./ImagesGallery.vue?vue&type=style&index=0&id=277d1b5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277d1b5e",
  null
  
)

export default component.exports